export function validate(record) {
    const errors = [];


    if (!record.useWhatsAppNotification && !record.useEmailNotification) {
        errors.push({ field: 'useWhatsAppNotification', message: 'Selecione ao menos um meio de notificação' });
    }

    if (record.useWhatsAppNotification) {
        if (!record.phoneWhatsApp || record.phoneWhatsApp === '') {
            errors.push({ field: 'phoneWhatsApp', message: 'Informe o número do WhatsApp' });
        }
    }

    if (record.useEmailNotification) {
        if (!record.email || record.email === '') {
            errors.push({ field: 'email', message: 'Informe o e-mail' });
        }
    }

    if (!record.notificationOccurrences || record.notificationOccurrences.length == 0) {
        errors.push({ field: 'notificationOccurrences', message: 'Selecione ao menos uma ocorrência' });
    }

    if (errors.length == 0) {
        console.log('OK');

    }

    const result = {
        ok: errors.length === 0,
        errors,
        record
    }

    return new Promise((resolve, reject) => {
        const action = result.ok ? resolve : reject;
        return action(result);
    })
}